import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DateTime from "components/Display/ViewDateTime";
import ClaimState from "../Display/ClaimState";

const ClaimStory = ({ claimStoryList }) => {
  if (!claimStoryList){
    return (
      <div/>
    );
  }
  return (
    <div className="calc-setting-table ">
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="4" className="text-left calc-setting-table-header">Atburðar saga færslu</th>
        </tr>
        <tr>
          <th className="text-left">Dags. og tími</th>
          <th className="text-left">Aðgerð</th>
          <th className="text-left">Framkvæmt af</th>
          <th className="text-left">Staða færslu</th>
        </tr>
        </thead>
        <tbody>
        {claimStoryList.map(function(item,i){
          return(
            <tr key={i}>
              <td className="text-left"><DateTime data={item.storyDate}/></td>
              <td className="text-left">{item.story} </td>
              <td className="text-left">{item.userName} </td>
              <td className="text-left"><ClaimState data={item.claimState}/> </td>
            </tr>);
        })}
        </tbody>
      </table>
    </div>
  );
};

ClaimStory.propTypes = {
  claimStoryList: PropTypes.array,
};

export default ClaimStory;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Claim/ClaimStory.js